/**
 * Company: SPHMedia
 * Description: SectionContainer a container wrapper for sections of a list of articles in landing pages
 */

import ArrowRight from "@assets/icons/header-arrow-right.svg?react";
import Link from "@components/Link";
import clsx from "clsx";
import type { ReactElement, ReactNode } from "react";

const Header = ({
  title,
  theme,
  more,
  icon,
  newTab,
}: {
  title: string;
  theme: string;
  more?: string;
  icon?: ReactElement;
  newTab?: boolean;
}) => (
  <h1
    className={clsx(
      "text-header-3 border-divider-secondary mx-3 flex items-center gap-2 border-b pt-4 pb-2",
      theme === "dark"
        ? "text-primary-on-dark dark:border-divider-primary-on-dark"
        : "text-primary",
    )}
  >
    {icon ? <span>{icon}</span> : null}
    {more ? (
      <Link
        to={more}
        {...(newTab && { target: "_blank" })}
        className={clsx("group inline-flex cursor-pointer items-center gap-2")}
      >
        {title}
        <div
          className={clsx(
            "bg-button-primary flex size-6 items-center justify-center rounded-full p-1",
          )}
        >
          <ArrowRight className="size-6" />
        </div>
      </Link>
    ) : (
      <span className="inline-flex items-center gap-2">{title}</span>
    )}
  </h1>
);

export default function SectionContainer({
  title = "",
  theme = "light",
  children,
  more,
  bgImg,
  testId = "",
  className,
  icon,
  newTab,
  showHeader = true,
}: {
  title?: string;
  theme?: "light" | "dark";
  children: ReactNode | ReactNode[];
  more?: string;
  bgImg?: string;
  testId?: number | string;
  className?: string;
  icon?: ReactElement;
  newTab?: boolean;
  showHeader?: boolean;
}) {
  return (
    <div
      data-testid={`section-container-${testId}`}
      className={clsx(
        theme === "light"
          ? "bg-background-default"
          : "bg-background-primary-on-dark",
        className,
      )}
      style={
        bgImg
          ? {
              background: `linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url(${bgImg}) lightgray 50% / cover no-repeat`,
            }
          : {}
      }
    >
      <div className="mx-auto max-w-[1200px]">
        {showHeader ? (
          <Header
            title={title}
            theme={theme}
            more={more}
            icon={icon}
            newTab={newTab}
          />
        ) : null}
        {children}
      </div>
    </div>
  );
}
